import jwtDecode from "jwt-decode";
import React, { useEffect, useState } from "react";
import useUsuariosAPI, { LoginData, LoginResponse } from "../../usuarios/useUsuariosAPI";

export interface UsuariosContextProps
{
    user?: LoginResponse,
    signOut:() => void,
    signIn:(data:LoginData ) => Promise<LoginResponse | undefined>,
    checkAuth:() => boolean
}


const UsuariosContext = React.createContext<UsuariosContextProps>(null!);

export default UsuariosContext;
export function UsuariosProvider(props:{children:React.ReactNode}){
    const api = useUsuariosAPI();
    const [user, setUser] = useState<LoginResponse>();
    
    function signOut()
    {
        localStorage.removeItem("_user");
        localStorage.removeItem("_token");
        localStorage.removeItem("_idsEquipoJuzgado");        
        window.location.reload()
    }

    async function signIn(loginData:LoginData)
    {
        const response = await api.login(loginData);

        if(response.error)
        {
            return undefined;
        }
       
        setUser(response.data!.value);
        localStorage.setItem("_user",JSON.stringify(response.data!.value));
        localStorage.setItem("_token",response.data!.value.token);

        const identificadoresEquipoJuzgado = JSON.stringify(response.data!.value.identificadoresEquipoJuzgado);
        localStorage.setItem("_idsEquipoJuzgado",identificadoresEquipoJuzgado);        
     
        return response.data!.value;
        
    }

    const checkValidToken = (fechaValidez: string) => {
        const dateExp = new Date(fechaValidez).getTime();
        const actualDate = new Date().getTime();
        return actualDate <= dateExp;
    }

    function checkAuth()
    {

        try {
            const user:LoginResponse = JSON.parse(localStorage.getItem("_user") ?? "");
            const result = jwtDecode<{exp:number}>(user.token);
            const dateExp = new Date(result.exp).getTime();
            const actualDate = new Date().getTime();

            if(!result || actualDate <= dateExp)
            {
                return false;
            }
            setUser(user);
            return true;

        } catch (error) {
            return false;
        }
    

    }

    const value:UsuariosContextProps = {
        signIn,
        signOut,
        checkAuth,
        user
    }

    return <UsuariosContext.Provider value={value}>{props.children}</UsuariosContext.Provider>;
}
